import { Actions } from '../constants';
import { isExperimentPlaying } from '../selectors';

const playExperiment = (name, variant, userIdentifier) => ({
  type: Actions.PLAY_EXPERIMENT,
  payload: name,
  meta: {
    analytics: {
      type: `Experiment started: ${name}`,
      payload: {
        variant,
        nonInteraction: 1,
        ha_anonymous_id: userIdentifier,
      },
    },
  },
});

export default (name, variant, userIdentifier) => (dispatch, getState) => {
  if (!isExperimentPlaying(getState(), { name })) {
    dispatch(playExperiment(name, variant, userIdentifier));
  }
};
